export default __webpack_public_path__ + "static/media/Icon-angle-left-darker.fb8230c9.svg";